import { useEffect, useState } from "react";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import { db } from "../../firebase"; // підкоригуй шлях
import css from "./adm.module.css"; // або свій css

const DOC_ID = "discountAndAction";

const DEFAULTS = {
  freeDelivery: "Безкоштовна доставка від 1000 грн",
  tenPercent: "10% знижки від 700 грн",
  fifteenPercent: "15% знижки від 990 грн",
  starchGift: "Фірмовий крохмаль пакет у подарунок",
  communityTreats: "Смаколики для спільноти",
};

export default function DiscountAndActionAdmin() {
  const [form, setForm] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);
  const [exists, setExists] = useState(false);

  useEffect(() => {
    const fetchDoc = async () => {
      try {
        const ref = doc(db, "mainPage", DOC_ID);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          setForm({ ...DEFAULTS, ...snap.data() });
          setExists(true);
        } else {
          setForm(DEFAULTS);
          setExists(false);
        }
      } catch (e) {
        console.error("Помилка читання Firestore:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchDoc();
  }, []);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const onSave = async () => {
    try {
      Swal.fire({
        title: "Збереження...",
        text: "Будь ласка, зачекайте.",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const ref = doc(db, "mainPage", DOC_ID);
      if (exists) {
        await updateDoc(ref, form);
      } else {
        await setDoc(ref, form);
        setExists(true);
      }

      Swal.close();
      Swal.fire("Готово!", "Дані збережено успішно.", "success");
    } catch (e) {
      console.error(e);
      Swal.close();
      Swal.fire("Помилка", "Не вдалося зберегти дані.", "error");
    }
  };

  const onResetToDefaults = () => setForm(DEFAULTS);

  if (loading) return <div>Завантаження...</div>;

  return (
    <div className={css.cardDiscCatalog}>
      <h2 className={css.title}>Знижки та акції (mainPage/{DOC_ID})</h2>

      <label className={css.label}>
        Безкоштовна доставка
        <input
          type="text"
          name="freeDelivery"
          value={form.freeDelivery}
          onChange={onChange}
          className={css.inputFotDisc}
        />
      </label>

      <label className={css.label}>
        10% знижки
        <input
          type="text"
          name="tenPercent"
          value={form.tenPercent}
          onChange={onChange}
          className={css.inputFotDisc}
        />
      </label>

      <label className={css.label}>
        15% знижки
        <input
          type="text"
          name="fifteenPercent"
          value={form.fifteenPercent}
          onChange={onChange}
          className={css.inputFotDisc}
        />
      </label>

      <label className={css.label}>
        Подарунковий крохмаль-пакет
        <input
          type="text"
          name="starchGift"
          value={form.starchGift}
          onChange={onChange}
          className={css.inputFotDisc}
        />
      </label>

      <label className={css.label}>
        Смаколики для спільноти
        <input
          type="text"
          name="communityTreats"
          value={form.communityTreats}
          onChange={onChange}
          className={css.inputFotDisc}
        />
      </label>

      <div className={css.actions}>
        <button onClick={onSave} className={css.saveButton}>
          {exists ? "Оновити" : "Створити документ"}
        </button>
        <button onClick={onResetToDefaults} className={css.secondaryButton}>
          Скинути на дефолт
        </button>
      </div>
    </div>
  );
}
